import React, { useEffect, useRef, useState } from "react";
import BackButton from "../../components/common/BackButton";
import { getData, postData } from "../../services/api.service";
import {
  swalAlertDanger,
  swalAlertInfo,
  swalAlertSuccess,
  swalConfirmationAlert,
} from "../../components/common/Alerts";
import TableDataRender from "../../components/common/TableDataRender";
import { FaPencilAlt } from "react-icons/fa";
import ModalWindow from "../../components/ModalWindow";
import FormEditSchedule from "./components/forms/FormEditSchedule";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

const AdminSchedule = () => {
  const tableRef = useRef();
  const navigate = useNavigate();
  const { id_branch } = useParams();
  const dataUser = useSelector((state) => state.user.dataUser);

  const [targets, setTargets] = useState();
  const [statusBranch, setStatusBranch] = useState();
  const [selectedTarget, setSelectedTarget] = useState(null);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [deliveryPrice, setDeliveryPrice] = useState("");

  const fetchData = async () => {
    if (dataUser === null || dataUser.role_id !== 1) {
      navigate("/");
    }

    const res = await getData(`/api/admin/admin_get_targets/${id_branch}`);

    const resBranch = await getData(
      `/api/admin/get_status_branch/${id_branch}`
    );

    if (res.status === 200) {
      setTargets(res.data.targets);
    } else {
      swalAlertDanger("Error", "No se encontraron horarios del día", () => {});
    }

    if (resBranch.status === 200) {
      setStatusBranch(resBranch.data.branch);
      setDeliveryPrice(resBranch.data.branch[0]?.delivery_price || "");
    } else {
      swalAlertDanger(
        "Error",
        "No se encontró el estado de la sucursal",
        () => {}
      );
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleEdit = async (data) => {
    await postData("/api/admin/update_target_id", data).then((res) => {
      if (res.status === 200) {
        fetchData();
        setShowModalEdit(false);
        swalAlertSuccess("Éxito", "Horario actualizado correctamente", () => {});
      } else if (res.status === 203) {
        swalAlertInfo("Error de validación", res.data.msg || "La hora no puede ser menor a la hora actual", () => {});
      } else {
        swalAlertInfo("Error", "No se pudo actualizar el horario", () => {});
      }
    }).catch((error) => {
      if (error.response && error.response.status === 203) {
        swalAlertDanger("Error de validación", error.response.data.msg || "La hora no puede ser menor a la hora actual", () => {});
      } else {
        swalAlertDanger("Error", "No se pudo actualizar el horario", () => {});
      }
    });
  };

  const handleBranchStatusChange = async (isOpen) => {
    const newClosedValue = isOpen ? 0 : 1; // Si está abierto = 0, si está cerrado = 1

    swalConfirmationAlert(
      `¿Estás seguro de que deseas ${isOpen ? "abrir" : "cerrar"} la sucursal?`,
      `La sucursal quedará ${
        isOpen
          ? "abierta y los clientes podrán hacer pedidos"
          : "cerrada y los clientes no podrán hacer pedidos nuevos"
      }.`,
      async () => {
        try {
          const data = {
            branch_id: Number(id_branch),
            closed: newClosedValue,
          };

          const res = await postData("/api/admin/update_branch_status", data);
          if (res.status === 200) {
            fetchData(); // Actualizar datos
            swalAlertSuccess(
              "Éxito",
              `Sucursal ${isOpen ? "abierta" : "cerrada"} correctamente`,
              () => {}
            );
          } else {
            swalAlertDanger(
              "Error",
              "No se pudo actualizar el estado de la sucursal",
              () => {}
            );
          }
        } catch (error) {
          swalAlertDanger(
            "Error",
            "Error al conectar con el servidor",
            () => {}
          );
        }
      }
    );
  };

  const handleUpdateDeliveryPrice = async () => {
    try {
      const data = {
        branch_id: id_branch,
        delivery_price: parseFloat(deliveryPrice),
      };

      const res = await postData("/api/admin/update_delivery_price", data);
      if (res.status === 200) {
        fetchData(); // Actualizar datos
        swalAlertSuccess(
          "Éxito",
          "Precio de delivery actualizado correctamente",
          () => {}
        );
      } else {
        swalAlertDanger(
          "Error",
          "No se pudo actualizar el precio de delivery",
          () => {}
        );
      }
    } catch (error) {
      swalAlertDanger("Error", "Error al conectar con el servidor", () => {});
    }
  };

  const columnMapping = {
    FECHA: { key: "production_date", align: "center", dataType: "date" },
    "HORA DE ENTREGA": { key: "end_time", align: "center" },
    "MAX. PRODUCCION": { key: "production_target", align: "center" },
    "MAX. DELIVERY": { key: "delivery_target", align: "center" },
    EDITAR: {
      key: "edit",
      align: "center",
      render: (row) => (
        <button
          className="btn btn-warning"
          onClick={() => {
            setSelectedTarget(row);
            setShowModalEdit(true);
          }}
        >
          <FaPencilAlt />
        </button>
      ),
    },
  };

  return (
    <div className="container mt-5 text-white">
      <div>
        <button
          className="btn btn-outline-light mb-3"
          onClick={() => navigate(`/home/admin_panel/${id_branch}`)}
        >
          ← Volver al Panel
        </button>
      </div>
      <h3 className="text-center">Panel de Horarios</h3>
      <p className="text-center">Administrar horarios y cierre de negocio</p>

      {/* Control de estado de sucursal */}
      <div className="bg-white row shadow p-3 mb-3 rounded">
        <div className="col-6">
          <div className="d-flex align-items-center justify-content-center">
            <div className="form-check form-switch d-flex align-items-center">
              <input
                className="form-check-input me-3"
                type="checkbox"
                id="branchStatusSwitch"
                style={{ transform: "scale(1.3)" }}
                checked={statusBranch?.[0]?.closed === 0}
                onChange={(e) => handleBranchStatusChange(e.target.checked)}
              />
              <label
                className="form-check-label text-dark fs-5 fw-bold"
                htmlFor="branchStatusSwitch"
              >
                SUCURSAL{" "}
                {statusBranch?.[0]?.closed === 0 ? "ABIERTA" : "CERRADA"}
              </label>
            </div>
          </div>
          {statusBranch?.[0] && (
            <div className="text-center mt-2">
              <small className="text-muted">
                {statusBranch[0].branch_name} - {statusBranch[0].address}
              </small>
            </div>
          )}
        </div>
        <div className="col-6">
          <h3 className="text-center form-check-label text-dark fs-5 fw-bold">
            PRECIO DELIVERY
          </h3>
          <div className="d-flex align-items-center justify-content-center gap-3">
            <div className="text-center text-dark">
              <input
                type="number"
                value={deliveryPrice}
                onChange={(e) => setDeliveryPrice(e.target.value)}
                className="form-control"
                placeholder="$"
                style={{ width: "120px" }}
              />
            </div>
            <div>
              <button
                className="btn btn-success"
                onClick={handleUpdateDeliveryPrice}
              >
                Guardar
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white shadow p-3 mt-3">
        <TableDataRender
          data={targets}
          columnMapping={columnMapping}
          tableRef={tableRef}
          scroll={true}
        />
      </div>
      <ModalWindow
        title={"Editar rango de horario"}
        body={
          <FormEditSchedule
            selectedTarget={selectedTarget}
            handleEdit={handleEdit}
          />
        }
        modalOpen={showModalEdit}
        setModalOpen={setShowModalEdit}
        footer={"Solo se modificarán los datos para este turno."}
      />
    </div>
  );
};

export default AdminSchedule;
